require.register("ffss/component/doc/Menu", function(exports, require, module){
  $0
  
});

